import TableAction from "components/TableAction";

import isoToDate from "utils/isoToDate";
export const tableData = ({ onClick, newRoute }) => [
  {
    header: "actions",
    Component: ({ param }) => <TableAction {...{ param, newRoute, onClick }} />,
  },
  {
    header: "name",
    Component: ({ param }) => `${param.name}` || "Unknown",
  },

  {
    header: "email",
    Component: ({ param }) => param.email,
  },
  {
    header: "firebaseUserId",
    Component: ({ param }) => param.firebaseUid,
  },

  {
    header: "createdAt",
    Component: ({ param }) => isoToDate(param.createdAt),
  },
];
